export const THEMES: ITheme = {
    dark: {
        headerBackground: '#333333',
        headerColor: 'rgba(255,255,255,1)',
        headerBorder: '#252526',
        toolboxBackground: '#252526',
        toolboxColor: '#FFFFFF',
        toolboxBorder: 'rgba(33,33,33,0.92)',
        toolboxPanelBackgroung: '#252526',
        toolboxButton: '##313131',
        sidenavBackgroung: '#252526',
        toolboxItemActiveBackgroung: '#3059af',
        toolboxItemActiveColor: '#FFFFFF',
        toolboxFlyColor: '#FFFFFF',
        footZoomBackground: '#212121',
        footZoomBackgroundHover: '#161616',
        footZoomColor: '#FFFFFF',
        svgEditRulersBackground: '#2f2f2f',
        svgEditRulersColor: '#A4A4A4',
        svgEditWorkareaBackground: '#434343',
        svgEditWorkareaContextMenu: '#212121',
        svgEditWorkareaContextMenuHighlight: '#424242',
        svgEditWorkareaContextColor: '#FFFFFF',
        formInputBackground: '#37373D',
        formExtInputBackground: '#2d2d2d',
        formInputColor: '#FFFFFF',
        formInputReadonlyBackground: '#37373D',
        formInputBorderFocus: '#1177BB',
        formInputBackgroundFocus: '#37373D',
        formSliderBackground: '#37373D',
        formSeparatorColor: '#37373D',
        formBorder: 'rgba(33,33,33,0.92)',
        setupSeparatorColor: '#808080',
        workPanelBackground: '#424242',
        mapBorderColor: '#333333',
        formExtBackground: '#37373D',
        formInputExtBackground: '#424242',
        formWrapperBackground: '#f1f3f4',
        mdcDialogContainerColor: '#FFFFFF',
    },
};

interface ITheme {
    [key: string]: {
        [key: string]: string;
    };
}
